import React, { useState, useCallback } from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import { Link } from 'gatsby';

import box from './assets/box.png';
import style from './LoveBox.module.less';
import { Section } from '../Section';

interface LoveBoxProps {
  alternate?: boolean;
}

export const LoveBoxSection: React.FC<LoveBoxProps> = (props) => (
  <Section className={style.loveBox} alternate={props.alternate}>
    <div className={style.content}>
      <h1 id="newsletter">Send a free Box with a hidden message</h1>
      <div className={style.row}>
        <div className={style.story}>
          <h2>Prepare a special message</h2>
          <p>What's the message you want to send? Can be warm words, can be a date location reveal, can be clever joke... Go wild and prepare something neat!</p>
          <h2>Share a unique link</h2>
          <p>Send an e-mail with a special, unique link. Your recipient will receive a message hidden behind a puzzle box.</p>
          <h2>Done!</h2>
          <p>That's it, that's all. The puzzles are simple, the device is cute, and the message is yours!</p>
          <div className={style.readMore}>
            <Link to="/message" className={style.learnMore}>Learn more →</Link>
          </div>
        </div>
        <div className={style.box}>
          <img src={box} alt="Love Box" />
        </div>
      </div>
    </div>
  </Section>
);
